import type { GetterTree } from "vuex";
import type { AlertEventStat, RootState, StatState } from "@/types";

export const getters: GetterTree<StatState, RootState> = {
  getAlertEventStat(state): AlertEventStat[] {
    return state.alertEvent.data;
  },
  getAlertEventStatLoading(state): boolean {
    return state.alertEvent.loading;
  },
  getAlertEventStatError(state): string | null {
    return state.alertEvent.error;
  },
};
